import React, { Component } from "react";
import { Link } from "react-router-dom";
import { authService } from "../../auth/services/auth";
import classnames from "classnames";
import Slide from "react-reveal/Slide";
import { Col, Collapse } from "reactstrap";
import { Page } from "../../core";
import Onboarding from "../../shell/components/Onboarding";
import { userProfileService } from "../services/profile";
import { userService } from "../services/user";
import profile from "../../core/assets/images/profile.png";
import { store } from "../../store";
import { setUserDetails } from "../../actions";
import moment from "moment";
import { middlewareService } from "../../shared/service";
import middlewareConstants from "../../shared/middleware-constant";
import { setBse } from "../../actions";
import { isMobile } from 'react-device-detect';
import {
  Helpers as BseHelpers,
  Helpers,
} from "../../shell/components/onboarding/bse/halper/index";
import aboutIcon from "../../assets/profile-drawer/about.svg";
import contactIcon from "../../assets/profile-drawer/contact.svg";
import logoutIcon from "../../assets/profile-drawer/logout.svg";
import personIcon from "../../assets/profile-drawer/person.svg";
import whatsupIcon from "../../assets/profile-drawer/whatsapp.svg";
import bellIcon from "../../assets/profile-drawer/bellicon.svg";
import refer from "../../assets/profile-drawer/referDrawer.svg";
import learn from "../../assets/profile-drawer/learn.svg"
import faqDrawer from "../../assets/profile-drawer/faqDrawer.svg"
import ToogleBtn from "./ToogleButton";
class UserProfileDrawerBse extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      showPansList: false,
      showAddAccountFlow: false,
      showBseFlow: false,
      isMyInvestmentOpen: false,
      isMyProfileOpen: false,
      isAboutOpen: false,
      isLearnOpen: false,
      panName: "",
    };

    this.logout = this.logout.bind(this);
    this.setDefaultPan = this.setDefaultPan.bind(this);
    this.togglePansList = this.togglePansList.bind(this);
    this.addAccount = this.addAccount.bind(this);
    this.closeAddAccountFlow = this.closeAddAccountFlow.bind(this);
    this.refreshUserData = this.refreshUserData.bind(this);
  }

  
  componentDidMount() {
    window.onhashchange = () => {
      let link = window.location.hash.split("/").slice(-1);
      if (link) {
        this.setState({
          product: link
        })
      }

    }
    let accounts = store.getState().bse.data;
    if (!accounts) {
      //this.getBseAccountsList();
      return;
    }
    this.setState({ uniquePAN: Helpers.getUniquePan(accounts) });
  }

  logout(event) {
    authService.logout(this.props.isMf);
  }

  // getBseAccountsList = () => {
  //   let _url = "/bse/accounts";
  //   let requestOptions = middlewareConstants.requestWithCredentials;
  //   middlewareService
  //     .serviceGet(process.env.REACT_APP_REPORTS_API_URL + _url, requestOptions)
  //     .then((response) => {
  //       if (response.success && response.result && response.result.length) {
  //         let bse = { ...store.getState().bse };
  //         bse.data = response.result;
  //         bse.hasBseAccount = true;
  //         bse.showBseCard = false;
  //         store.dispatch(setBse(bse));

  //         this.setState({
  //           uniquePAN: Helpers.getUniquePan(response.result),
  //         });
  //       }
  //     });
  // };

  setDefaultPan(userPanDetails) {
    if (userPanDetails.pan === "all") {
      this.props.onDefaultPanSelected({ name: "All PANs" });
    } else {
      userProfileService.setDefaultPan(userPanDetails.pan).then((response) => {
        if (response.success) {
          this.props.onDefaultPanSelected(userPanDetails);
          this.setState({ panName: userPanDetails.name });
        }
      });
    }
  }

  togglePansList() {
    this.setState({
      showPansList: !this.state.showPansList,
    });
  }

  toggleMyInvestment = (e) => {
    e.stopPropagation();
    this.setState({
      isMyInvestmentOpen: !this.state.isMyInvestmentOpen,
      isMyProfileOpen: false,
      isAboutOpen: false,
      isMyNotificationsOpen: false,
    });
  };

  toggleMyProfile = (e) => {
    e.stopPropagation();
    this.setState({
      isMyProfileOpen: !this.state.isMyProfileOpen,
      isMyInvestmentOpen: false,
      isAboutOpen: false,
      isMyNotificationsOpen: false,
    });
  };

  toggleMyObProfile = (e) => {
    window.location.href = `${process.env.REACT_APP_URL_ENDPOINTS}/profile`;
    this.props.onUserProfileCloseClicked();
  };

  toggleMyReferProfile = (e) => {
    window.location.href = process.env.REACT_APP_BASE_URL_ICM + "/refer";
    this.props.onUserProfileCloseClicked();
  };
  
  toggleMyFaqProfile = (e) => {
    window.location.href = "/platform/#/faq";
    this.props.onUserProfileCloseClicked();
  };

  toggleReports = () => {
    window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + "/biddeasy-reports";
    this.props.onUserProfileCloseClicked();
  }

  toggleMyOpProfile = (e) => {
    window.location.href = "/platform/#/alternate-assets";
    this.props.onUserProfileCloseClicked();
  };

  toggleMyOmProfile = (e) => {
    window.location.href = "/platform/#/";
    this.props.onUserProfileCloseClicked();
  };
  
  toggleMyOpProfile = (e) => {
    window.location.href = "/platform/#/alternate-assets";
    this.props.onUserProfileCloseClicked();
  };

  toggleMyOmProfile = (e) => {
    window.location.href = "/platform/#/";
    this.props.onUserProfileCloseClicked();
  };

  toggleAbout = (e) => {
    e.stopPropagation();
    this.setState({
      isAboutOpen: !this.state.isAboutOpen,
      isMyInvestmentOpen: false,
      isMyProfileOpen: false,
      isMyNotificationsOpen: false,
    });
  };
  toggleLearn = (e) => {
    e.stopPropagation();
    this.setState({
      isLearnOpen: !this.state.isLearnOpen,
      isAboutOpen: false,
      isMyInvestmentOpen: false,
      isMyProfileOpen: false,
      isMyNotificationsOpen: false,
    });
  };
  toggleMyNotifications = (e) => {
    e.stopPropagation();
    this.setState({
      isMyNotificationsOpen: !this.state.isMyNotificationsOpen,
      isMyInvestmentOpen: false,
      isMyProfileOpen: false,
      isAboutOpen: false,
    });
  };

  addAccount() {
    let bse = store.getState().bse || {};
    let bseVsMfu = BseHelpers.isCpdForMfuOrBse(
      store.getState().user &&
        store.getState().user.userDetails &&
        store.getState().user.userDetails.cpd[0] &&
        store.getState().user.userDetails.cpd[0].CPD,
      bse.hasBseAccount
    );

    if (bse.showBseCard || bse.hasBseAccount || bseVsMfu.isBseUser) {
      this.setState({
        showBseFlow: true,
      });
      return;
    }

    this.setState({
      showAddAccountFlow: true,
    });
  }

  completeBseAccountSetup = (status) => {
    if (status === "KYC_COMPLETE") {
      this.props.redirectTo("/add-bank/verify", {
        bseFormManageAccount: true,
        dashboardtToTrack: true,
      });
    }

    this.setState({
      showAddAccountFlow: false,
      showBseFlow: false,
    });
  };

  closeAddAccountFlow() {
    this.setState({
      showAddAccountFlow: false,
    });

    this.refreshUserData();
  }

  refreshUserData() {
    userService.getUserData().then((response) => {
      store.dispatch(setUserDetails(response));
      this.props.onOnboardingClosed();
    });
  }

  handleLearnClick = () => {
    window.open(`${process.env.REACT_APP_URL_ENDPOINTS}/blog`, "_blank")
  }

  getPlanExpiry() {
    let daysLeft = 0;
    if (store.getState().pricing && store.getState().pricing.currentPlan) {
      let currentPlan = store.getState().pricing.currentPlan;
      if (currentPlan.plan !== "free") {
        let startDate = moment(new Date(currentPlan.expiry));
        let currDate = moment();
        daysLeft = startDate.diff(currDate, "days");
      }
    }
    return daysLeft;
  }

  // scrollToBottom = () => {
  //   this.finalBlock.scrollIntoView({ behavior: "smooth" });
  // };

  trackScrolling = () => {
    const wrappedElement = document.getElementById("userDrawer");
    if (this.isBottom(wrappedElement)) {
      document.removeEventListener("scroll", this.trackScrolling);
    }
  };

  getExpiryDate = (expiry) => {
    let date = moment(new Date(expiry || null));
    return date.format("D MMM YYYY");
  };

  getBseAccount = () => {
    this.setState({
      bseAccountInfoLoading: true,
    });

    let _url = "/bse/accounts";
    let requestOptions = middlewareConstants.requestWithCredentials;

    middlewareService
      .serviceGet(process.env.REACT_APP_REPORTS_API_URL + _url, requestOptions)
      .then((response) => {
        this.setState({
          bseAccountInfoLoading: false,
        });
        if (response.success && response.result && response.result.length) {
          this.setState({
            hasBseAccount: true,
          });
        }
      });
  };

  render() {
    let pans = store.getState()?.user?.validPans?.pans;
    let daysToExpiry = this.getPlanExpiry();
    let bseAccountData = store.getState().bse;
    if (this.props.show) {
      var storeState = store.getState();
      var canDetails = storeState.user.canDetails;
      var userPans = storeState.user.validPansList
        ? storeState.user.validPansList
        : [];
      var defaultPanDetails = storeState.user.defaultPanDetails
        ? storeState.user.defaultPanDetails[0]
        : "";
      var currentPlan = storeState.pricing.currentPlan;
      var transactionLimits = storeState.pricing.transactionLimits;
      var plansList = storeState.pricing.plans;
      var walletBalance = storeState.wallet.value;
      var defaultUserDetails = storeState.user.defaultUserDetails
        ? storeState.user.defaultUserDetails
        : "";
      var obTpdDetails = storeState.obTpd || {};

      return (
        <Page className="h-100 user-profile-drawer-container">
          <Col
            xs={12}
            md={6}
            lg={8}
            className="cursor-pointer bg-light h-100 content p-0"
          >
            <div
              className="w-100 h-100"
              onClick={this.props.onUserProfileCloseClicked}
            ></div>
            {this.state.showBseFlow ? (
              <Onboarding
                isBseFlow={true}
                onOnboardingCompleted={this.completeBseAccountSetup}
                redirectTo={this.props.redirectTo}
              />
            ) : (
              ""
            )}

            <Onboarding
              type="add-account"
              onOnboardingCompleted={this.closeAddAccountFlow}
              isOpen={this.state.showAddAccountFlow}
              redirectTo={this.props.redirectTo}
            />
          </Col>
          <Col
            xs={12}
            lg={4}
            md={6}
            className="h-100 text-white sidebar"
            id="userDrawer"
          >
            <span
              className="profile-drawer-close d-md-none d-sm-block d-block mdi mdi-close text-white"
              onClick={this.props.onUserProfileCloseClicked}
            ></span>
            <div className="d-flex h-100 align-items-center sidebar-content">
              <Slide right duration={300}>
                <div className="account-details-container w-100 py-6">
                  <div className="d-flex flex-row account-details" style={{cursor : "pointer"}} onClick={ obTpdDetails.userInHypervergeCug ? this.toggleMyObProfile : null}>
                    {process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                      <div className="profile-pic mr-3">
                        <img src={obTpdDetails.userInHypervergeCug ? personIcon : profile} alt="" className="w-100 h-100" />
                      </div>
                    )}
                    {process.env.REACT_APP_AMAZON_DASHBOARD === "false" && 
                    (
                      <div className="d-flex flex-column ">
                        <p className="text-light font-weight-semi-bold mb-1">
                          {obTpdDetails.name
                            ? obTpdDetails.name
                            : obTpdDetails.email ? obTpdDetails.email : null}
                        </p>
                        <p className="text-muted font-weight-medium font-size-small mb-2">
                          {obTpdDetails.userInHypervergeCug ? "Profile Details" : obTpdDetails.pan
                            ? obTpdDetails.pan
                            : ""}
                        </p>
                      </div>
                    )}
                  </div>
                  {!this.props.isOrobonds &&
                    <>
                      { this.props.isOrobonds && process.env.REACT_APP_AMAZON_DASHBOARD === "false" &&
                        defaultPanDetails ? (
                        <div
                          className="mt-3 font-size-small text-light font-weight-medium px-4 cursor-pointer account-details"
                          onClick={this.togglePansList}
                        >
                          <p className="text-light font-weight-semi-bold mb-2">
                            {defaultPanDetails.name
                              ? defaultPanDetails.name
                              : defaultPanDetails.isAutomatic
                              ? "Automatically added"
                              : defaultPanDetails.nickName}
                            <i
                              className={classnames(
                                "text-muted mdi",
                                {
                                  "mdi-chevron-down font-size-normal": !this.state
                                    .showPansList,
                                },
                                {
                                  "mdi-chevron-up font-size-normal": this.state
                                    .showPansList,
                                }
                              )}
                            ></i>
                          </p>
                          {this.state.panName && (
                            <p className="font-size-tiny mb-0">
                              {this.state.panName} - {defaultPanDetails.pan}
                            </p>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      { process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                        <ul
                          className={classnames(
                            "all-pans mt-2",
                            { "d-none": !this.state.showPansList },
                            { "d-block is-open": this.state.showPansList }
                          )}
                        >
                          <li
                            className="cursor-pointer"
                            onClick={() => this.setDefaultPan({ pan: "all" })}
                          >
                            <div className="d-flex flex-column">
                              <h6 className="text-light mb-2">All</h6>
                            </div>
                          </li>
                          {process.env.REACT_APP_AMAZON_DASHBOARD === "false" &&
                            pans?.length > 0 &&
                            pans.map((item, index) => (
                              <li
                                className="cursor-pointer"
                                onClick={() => this.setDefaultPan(item)}
                                key={index}
                              >
                                <div className="d-flex flex-column">
                                  {item.name ? (
                                    <p className="font-size-tiny">
                                      {item.pan} - {item.name}
                                    </p>
                                  ) : (
                                    <p className="font-size-tiny">{item.pan}</p>
                                  )}
                                </div>
                              </li>
                            ))}
                        </ul>
                      )}
                      {/* { 
                        <div className="d-flex flex-row account-details justify-content-between">
                          <div className="mt-2 font-size-small text-light font-weight-medium px-2 d-inline-block p-2 manage-profile">
                            <i className="text-muted mdi mdi-wrench font-size-small mr-2"></i>
                            <a
                              className="manage-accounts-link cursor-pointer mb-0"
                              onClick={() =>
                                this.props.redirectTo("/profile", {
                                  userDetails: this.state.userDetails,
                                })
                              }
                            >
                              Manage Accounts
                            </a>
                          </div>
                          <div className="mt-2 font-size-small text-light font-weight-medium px-2 d-inline-block p-2 manage-profile">
                            <i className="text-muted mdi mdi-plus font-size-small mr-2"></i>
                            <a
                              className="manage-accounts-link cursor-pointer mb-0"
                              onClick={this.addAccount}
                            >
                              Add an account
                            </a>
                          </div>
                        </div>
                      } */}
                    </>
                  }
                </div>
                {/* {!this.props.isOrobonds &&
                  currentPlan && currentPlan.plan != "free" ? (
                  <div className="plan-details w-100 text-dark cursor-pointer">
                    <div className="font-size-tiny text-muted">Your plan</div>
                    <p className="font-size-large font-weight-semi-bold">
                      {currentPlan.plan.charAt(0).toUpperCase() +
                        currentPlan.plan.slice(1)}
                    </p>
                    {daysToExpiry > 0 ? (
                      <div className="font-size-tiny text-danger">
                        Expires on{" "}
                        <span>{this.getExpiryDate(currentPlan.expiry)}</span>
                      </div>
                    ) : (
                      <div className="font-size-tiny text-danger">
                        Expired on{" "}
                        <span>{this.getExpiryDate(currentPlan.expiry)}</span>
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )} */}

                <ul className="settings-menu list-unstyled mb-0">
                  {!this.props.isOrobonds &&
                    <>
                      {/* { this.props.isOrobonds && process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                        <li
                          className="menu-item"
                          onClick={this.props.onUserProfileCloseClicked}
                        >
                          <Link exact="true" to="/track-portfolio">
                            <img src={chartIcon} className="mr-2" />
                            <span>Track your Portfolio</span>
                          </Link>
                        </li>
                      )} */}
                      {/* { this.props.isOrobonds && process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                        <li className="menu-item" onClick={this.toggleMyInvestment}>
                          <Link to="#">
                            <img src={investmentIcon} className="mr-2" />{" "}
                            <span>My Investments</span>
                            <i
                              className={
                                this.state.isMyInvestmentOpen
                                  ? "mdi mdi-chevron-down font-size-small"
                                  : "mdi mdi-chevron-right font-size-small"
                              }
                            ></i>
                          </Link>
                          <Collapse isOpen={this.state.isMyInvestmentOpen}>
                            <li
                              className="menu-item"
                              onClick={this.props.onUserProfileCloseClicked}
                            >
                              <Link
                                exact="true"
                                to="/add-accounts"
                                className="pl-8 font-size-small"
                              >
                                Banks and Setup Autopay
                              </Link>
                            </li>
                            <li
                              className="menu-item"
                              onClick={this.props.onUserProfileCloseClicked}
                            >
                              <Link
                                exact="true"
                                to="/portfolio"
                                className="pl-8 font-size-small"
                              >
                                Active SIPs
                              </Link>
                            </li>
                            {process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                              <li
                                className="menu-item"
                                onClick={this.props.onUserProfileCloseClicked}
                              >
                                <Link
                                  exact="true"
                                  to="/reports"
                                  className="pl-8 font-size-small"
                                >
                                  My Reports
                                </Link>
                              </li>
                            )}
                            {((storeState.user.userDetails &&
                              storeState.user.userDetails.cpd &&
                              storeState.user.userDetails.cpd.length &&
                              storeState.user.userDetails.cpd[0] &&
                              storeState.user.userDetails.cpd[0].CPD) ||
                              (bseAccountData && bseAccountData.hasBseAccount)) &&
                              process.env.REACT_APP_AMAZON_DASHBOARD ===
                                "false" && (
                                <li
                                  className="menu-item"
                                  onClick={this.props.openRiskModal}
                                >
                                  <p className="pl-8 font-size-small">
                                    My Risk Profile
                                  </p>
                                </li>
                              )}
                          </Collapse>

                          <ul className="settings-menu list-unstyled mb-0"></ul>
                        </li>
                      )} */}
                      { this.props.isOrobonds && process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                        <li className="menu-item" onClick={this.toggleMyProfile}>
                          <Link to="#">
                            {" "}
                            <img src={personIcon} className="mr-2" alt="personIcon"/>
                            <span>Mutual Funds Profile</span>
                            <i
                              className={
                                this.state.isMyProfileOpen
                                  ? "mdi mdi-chevron-down font-size-small"
                                  : "mdi mdi-chevron-right font-size-small"
                              }
                            ></i>
                          </Link>
                          <Collapse isOpen={this.state.isMyProfileOpen}>
                            {bseAccountData && bseAccountData.hasBseAccount ? (
                              <li
                                className="menu-item"
                                onClick={this.props.onUserProfileCloseClicked}
                              >
                                <Link
                                  exact="true"
                                  to="/docs-valut"
                                  className="pl-8 font-size-small"
                                >
                                  My Documents
                                </Link>
                              </li>
                            ) : (
                              ""
                            )}
                            <li
                              className="menu-item"
                              onClick={this.props.onUserProfileCloseClicked}
                            >
                              <Link
                                exact="true"
                                to="/setup-password"
                                className="pl-8 font-size-small"
                              >
                                Change Password
                              </Link>
                            </li>
                          </Collapse>

                          <ul className="settings-menu list-unstyled mb-0"></ul>
                        </li>
                      )}
                    </>
                  }
                  {
                  // this.props.isOrobonds && 
                  obTpdDetails.userInHypervergeCug ? null : process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                    <li className="menu-item" onClick={this.toggleMyObProfile}>
                      <Link to="#">
                        {" "}
                        <img src={personIcon} className="mr-2" alt="personIcon" />
                        <span>Profile</span>
                      </Link>
                    </li>
                  )}
                  {
                    process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                    <li className="menu-item" onClick={this.toggleMyReferProfile}>
                      <Link to="#">
                        {" "}
                        <img src={refer} 
                         width="24"
                         height="24"
                         alt="refer"
                        className="mr-2" />
                        <span>Refer & Earn</span>
                      </Link>
                    </li>
                  )}
                  {
                    process.env.REACT_APP_AMAZON_DASHBOARD === "false" && isMobile ?(
                    <li className="menu-item" onClick={this.toggleMyFaqProfile}>
                      <Link to="#">
                        {" "}
                        <img src={faqDrawer}  
                         width="24"
                         height="24"
                         alt="refer"
                        className="mr-2" />
                        <span>FAQs</span>
                      </Link>
                    </li>
                  ):""}

                  <li className="menu-item" onClick={this.handleLearnClick}>
                    <Link to="#">
                      {" "}
                      <img src={learn}
                        width="24"
                        height="24"
                        alt="learn"
                        className="mr-2"
                      />
                      <span>Learn</span>
                    </Link>
                  </li>

                  {/* {process.env.REACT_APP_AMAZON_DASHBOARD === "false" &&  isMobile ?(
                    <li className="menu-item" onClick={this.toggleLearn}>
                      <Link to="#">
                        <img src={learn} alt="aboutIcon" className="mr-2" />
                        Learn
                        <i
                          className={
                            this.state.isAboutOpen
                              ? "mdi mdi-chevron-down font-size-small"
                              : "mdi mdi-chevron-right font-size-small"
                          }
                        ></i>
                      </Link>
                      <Collapse isOpen={this.state.isLearnOpen}>
                        <li
                          className="menu-item"
                          onClick={this.props.onUserProfileCloseClicked}
                        >
                          <a
                            href={process.env.REACT_APP_BLOGS_POST_URL}
                            rel="noopener noreferrer"
                            className="pl-8 font-size-small"
                          >
                           Blogs
                          </a>
                        </li>
                      </Collapse>
                      <Collapse isOpen={this.state.isLearnOpen}>
                        <li
                          className="menu-item"
                          onClick={this.props.onUserProfileCloseClicked}
                        >
                          <a
                            href="https://incredmoney.wpcomstaging.com/newsletters/"
                            rel="noopener noreferrer"
                            className="pl-8 font-size-small"
                          >
                           NewsLetters
                          </a>
                        </li>
                      </Collapse>
                      <ul className="settings-menu list-unstyled mb-0"></ul>
                    </li>
                  ):""} */}
                  {
                    process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                    <li className="menu-item" onClick={this.toggleReports}>
                      <Link to="#">
                         {" "}
                        <span class="mdi mdi-file-document"></span> Reports
                      </Link>
                    </li>
                  )}
                  {process.env.REACT_APP_PARTNER_NAME === "oro" &&
                  (this.props.isOrobonds &&
                  process.env.REACT_APP_AMAZON_DASHBOARD === "false") && (
                  <>
                    <li className="menu-item" onClick={this.toggleMyOpProfile}>
                      <Link to="#">
                        {" "}
                        <i className="mdi mdi-chart-line mr-2"/>
                        <span>Alternate Assets</span>
                      </Link>
                    </li>
                    <li className="menu-item" onClick={this.toggleMyOmProfile}>
                      <Link to="#">
                        {" "}
                        <i className="mdi mdi-chart-arc mr-2"/>
                        <span>Mutual Funds</span>
                      </Link>
                    </li>
                    </>
                  )}
                  {process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                    <li
                      className="menu-item"
                      onClick={this.toggleMyNotifications}
                    >
                      <Link to="#">
                        {" "}
                        <img
                          src={bellIcon}
                          alt="bellIcon"
                          width="24"
                          height="24"
                          className="mr-2"
                        />
                        <span>Notification Preferences</span>
                        <i
                          className={
                            this.state.isMyNotificationsOpen
                              ? "mdi mdi-chevron-down font-size-small"
                              : "mdi mdi-chevron-right font-size-small"
                          }
                        ></i>
                      </Link>
                      <Collapse isOpen={this.state.isMyNotificationsOpen}>
                        <li
                          className="menu-item"
                        
                        >
                          <div className="d-flex wa-toggle">
                            <div>
                              <img
                                style={{ marginRight: "-15px" }}
                                className="ml-5"
                                src={whatsupIcon}
                                alt="whatsapp-icon"
                              />
                            </div>
                            <div>
                              <a className="font-size-small wa-text">
                                WhatsApp Notification
                              </a>
                            </div>
                            <div className="wa-toggle-btn">
                              <ToogleBtn />
                            </div>
                          </div>
                        </li>
                      </Collapse>

                      <ul className="settings-menu list-unstyled mb-0"></ul>
                    </li>
                  )}
                  <li
                    className="menu-item"
                    onClick={this.props.onUserProfileCloseClicked}
                  >
                    <a
                      href={process.env.REACT_APP_BASE_URL_ICM + "/contact/"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={contactIcon} alt="contactIcon" className="mr-2" />
                      <span>Contact Us</span>
                    </a>
                  </li>
                  {process.env.REACT_APP_AMAZON_DASHBOARD === "false" && (
                    <li className="menu-item" onClick={this.toggleAbout}>
                      <Link to="#">
                        <img src={aboutIcon} alt="aboutIcon" className="mr-2" />
                        About
                        <i
                          className={
                            this.state.isAboutOpen
                              ? "mdi mdi-chevron-down font-size-small"
                              : "mdi mdi-chevron-right font-size-small"
                          }
                        ></i>
                      </Link>
                      <Collapse isOpen={this.state.isAboutOpen}>
                        <li
                          className="menu-item"
                          onClick={this.props.onUserProfileCloseClicked}
                        >
                          <a
                            href={process.env.REACT_APP_BASE_URL_ICM + "/about/"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pl-8 font-size-small"
                          >
                            About Us
                          </a>
                        </li>
                        <li
                          className="menu-item"
                          onClick={this.props.onUserProfileCloseClicked}
                        >
                          <a
                            href={process.env.REACT_APP_BASE_URL_ICM + "/terms-of-use/"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pl-8 font-size-small"
                          >
                            Terms & Conditions
                          </a>
                        </li>
                        <li
                          className="menu-item"
                          onClick={this.props.onUserProfileCloseClicked}
                        >
                          <a
                            href={process.env.REACT_APP_BASE_URL_ICM + "/privacy-policy/"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pl-8 font-size-small"
                          >
                            Privacy Policy
                          </a>
                        </li>
                        <li
                          className="menu-item"
                          onClick={this.props.onUserProfileCloseClicked}
                        >
                          <a
                            href={process.env.REACT_APP_BASE_URL_ICM + "/disclaimer/"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pl-8 font-size-small"
                          >
                            Disclaimer
                          </a>
                        </li>
                      </Collapse>
                      <ul className="settings-menu list-unstyled mb-0"></ul>
                    </li>
                  )}
                  <li className="menu-item" onClick={this.logout}>
                    <p>
                      <img src={logoutIcon} alt="logout-icon" className="mr-2" />
                      Logout
                    </p>
                  </li>
                </ul>

                <div
                  ref={(el) => {
                    this.finalBlock = el;
                  }}
                  className={classnames("dummy-block p-4", { "d-none": false })}
                ></div>
              </Slide>
            </div>
          </Col>
        </Page>
      );
    } else {
      return <div></div>;
    }
  }
}

export default UserProfileDrawerBse;
